import { Stack, Tag, Text } from '@chakra-ui/react'

import UserAvatar from '@/components/UserAvatar'

export default function UserProfile({
  avatarUrl,
  name,
  role,
}: {
  avatarUrl: string
  name: string
  role: string
}): React.ReactElement {
  return (
    <Stack alignItems={['flex-start', 'center']} direction={['column', 'row']} spacing={2} mb={4}>
      <UserAvatar src={avatarUrl} name={name} size="sm" progressionLevel={null} />
      <Text fontWeight="bold">{name}</Text>
      <Tag backgroundColor="blue.subtle" color="blue.solid" fontWeight="bold" fontSize="small">
        {role}
      </Tag>
    </Stack>
  )
}
